
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g2oof", function(module, exports) {
/* ViewPageCommon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $iHQDd = parcelRequire("iHQDd");


var $jiJCD = parcelRequire("jiJCD");


var $inPa6 = parcelRequire("inPa6");


var $lxDfD = parcelRequire("lxDfD");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $lJlG6 = parcelRequire("lJlG6");


var $7mpOv = parcelRequire("7mpOv");


var $jmjWc = parcelRequire("jmjWc");


const $f23f475309e66803$export$9533f8bbe7f6f635 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZhro",
    name: "AIFloatingContextMenuLoadable",
    loader: async ()=>(await (parcelRequire("7mat2"))).AIFloatingContextMenu
});



var $cZa7r = parcelRequire("cZa7r");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $deZfn = parcelRequire("deZfn");


var $iVU5h = parcelRequire("iVU5h");


var $iSXh4 = parcelRequire("iSXh4");


var $cryCi = parcelRequire("cryCi");


var $fNzRA = parcelRequire("fNzRA");


var $4r9Ir = parcelRequire("4r9Ir");


var $7IghX = parcelRequire("7IghX");


var $9jl6v = parcelRequire("9jl6v");


var $8SCD6 = parcelRequire("8SCD6");


var $8i27m = parcelRequire("8i27m");


var $hd53J = parcelRequire("hd53J");


var $4L9ve = parcelRequire("4L9ve");


var $3mVfX = parcelRequire("3mVfX");


var $iNYtG = parcelRequire("iNYtG");


var $dJ5r4 = parcelRequire("dJ5r4");


var $fyPYm = parcelRequire("fyPYm");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $jFm04 = parcelRequire("jFm04");


var $6pBXK = parcelRequire("6pBXK");


var $8amSw = parcelRequire("8amSw");


var $6UMDm = parcelRequire("6UMDm");


var $ayQVU = parcelRequire("ayQVU");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");





var $6fwOO = parcelRequire("6fwOO");


var $ivb8S = parcelRequire("ivb8S");


var $dPJCf = parcelRequire("dPJCf");


var $eC276 = parcelRequire("eC276");





var $daw2l = parcelRequire("daw2l");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");

const $8e93420dd4224227$var$useExportJiraContextToPageNudgeQueryParam = (0, $dPJCf.createSingleQueryParamHook)('export_source');
const $8e93420dd4224227$var$useResetTourQueryParam = (0, $dPJCf.createSingleQueryParamHook)('resetTour');
const $8e93420dd4224227$export$dd15d35ca66ec3f8 = ({ children: children })=>{
    const exportSource = $8e93420dd4224227$var$useExportJiraContextToPageNudgeQueryParam();
    const resetTour = $8e93420dd4224227$var$useResetTourQueryParam();
    const isEligible = exportSource === 'jiraTimelineExport';
    // Check if tour has been completed or dismissed
    const { data: tourStateData, loading: tourStateLoading, error: tourStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_COMPLETED,
        (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_DISMISSED
    ]);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const hasCompletedTour = tourStateData?.onboardingState?.find((prop)=>prop.key === (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_COMPLETED)?.value === 'true';
    const hasDismissedTour = tourStateData?.onboardingState?.find((prop)=>prop.key === (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_DISMISSED)?.value === 'true';
    const isOnboardingStateLoaded = Boolean(!tourStateLoading && !tourStateError && tourStateData);
    // Reset tour state if resetTour=1 query parameter is present and user is eligible
    (0, $42omo.useEffect)(()=>{
        if (resetTour === '1' && isEligible && isOnboardingStateLoaded) {
            setOnboardingState({
                key: (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_COMPLETED,
                value: 'false'
            });
            setOnboardingState({
                key: (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_DISMISSED,
                value: 'false'
            });
        }
    }, [
        resetTour,
        isEligible,
        isOnboardingStateLoaded,
        setOnboardingState
    ]);
    // Only show tour if eligible, onboarding state is loaded, and tour hasn't been completed or dismissed
    // If resetTour=1, we ignore the completed/dismissed state to allow the tour to show
    const shouldShowTour = isEligible && isOnboardingStateLoaded && (resetTour === '1' || !hasCompletedTour && !hasDismissedTour);
    const [shouldStartTour, setShouldStartTour] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // Delay tour start to ensure DOM targets are ready
        if (shouldShowTour) {
            setShouldStartTour(true);
            // Track that spotlight started
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'started',
                step: 0
            });
        } else if (isEligible && isOnboardingStateLoaded && hasCompletedTour) // Track skipped event for eligible users who already completed
        (0, $daw2l.trackSpotlightEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            action: 'skipped',
            step: null
        });
    }, [
        shouldShowTour,
        isEligible,
        isOnboardingStateLoaded,
        hasCompletedTour,
        createAnalyticsEvent
    ]);
    const handleTourComplete = ()=>{
        setOnboardingState({
            key: (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_COMPLETED,
            value: 'true'
        });
    };
    const handleTourDismiss = ()=>{
        setOnboardingState({
            key: (0, $eC276.EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR).TOUR_DISMISSED,
            value: 'true'
        });
    };
    // Handle errors and send operational event
    const handleError = (0, $42omo.useCallback)((error, errorInfo)=>{
        (0, $daw2l.trackErrorEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            error: error,
            errorInfo: errorInfo,
            componentName: 'export-jira-context-nudge'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
        renderOnError: ()=>children,
        onError: handleError
    }, isEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6fwOO.ExperimentExportJiraContextToPageNudgeSpotlightTour), {
        shouldShowTour: shouldStartTour && shouldShowTour,
        isEnrolled: isEligible,
        onTourComplete: handleTourComplete,
        onTourDismiss: handleTourDismiss
    }, children) : children);
};



var $aK6zf = parcelRequire("aK6zf");
/* ImportFeedbackBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $9FnLD = parcelRequire("9FnLD");


var $9zIwY = parcelRequire("9zIwY");





var $dpPtd = parcelRequire("dpPtd");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $jQob7 = parcelRequire("jQob7");


var $4mihy = parcelRequire("4mihy");

const $99af38a0b1766526$var$LOCAL_STORAGE_CONTENTID_LIMIT = 200; // 30 bytes per contentId, 200 is 6KB
const $99af38a0b1766526$var$IMPORT_SOURCE_NOTION = 'Notion';
const $99af38a0b1766526$var$translations = (0, $cgtv4.defineMessages)({
    bannerText: {
        id: "import-feedback.banner-text",
        defaultMessage: "This content is imported. How does it look?"
    }
});
const $99af38a0b1766526$var$styles = {
    root: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $99af38a0b1766526$var$unboundedStyles = {
    root: "_1bsb14oa _18u09b24 _kqswh2mm"
};
const $99af38a0b1766526$export$f2bf6e79bf9b9470 = ({ importSource: importSource, importDate: importDate, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false); //TODO (@rwang): Refactor this to use the ImportFeedbackStorageManager (CCIMPORTER-509)
    const [bannerDisabledContentIds, setBannerDisabledContentIds] = (0, $42omo.useState)(()=>JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_IMPORT_FEEDBACK_DISABLED)) || []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importFeedbackBanner'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleFeedbackClick = ()=>{
        setIsModalOpen(true);
    }; //TODO (@rwang): Refactor this to use the ImportFeedbackStorageManager (CCIMPORTER-509)
    const handleDismissClick = ()=>{
        if (bannerDisabledContentIds.length >= $99af38a0b1766526$var$LOCAL_STORAGE_CONTENTID_LIMIT) bannerDisabledContentIds.shift();
        const updatedIds = [
            ...bannerDisabledContentIds,
            contentId
        ];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_IMPORT_FEEDBACK_DISABLED, JSON.stringify(updatedIds));
        setBannerDisabledContentIds(updatedIds);
    };
    const formattedSource = importSource && $99af38a0b1766526$var$IMPORT_SOURCE_NOTION; // Hardcoded with Notion until backend is updated
    const isFeedbackDisabled = bannerDisabledContentIds.includes(contentId);
    if (isFeedbackDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $99af38a0b1766526$var$unboundedStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($99af38a0b1766526$var$styles.root),
        backgroundColor: "color.background.accent.purple.subtler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        gap: "space.400",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $99af38a0b1766526$var$translations.bannerText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))),
        label: "Thumbs Up",
        testId: "import-feedback-banner-thumbs-up-button",
        onClick: ()=>{
            (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackBanner', formattedSource, importDate, contentId, 'positive');
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'thumsUpButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
            handleDismissClick();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))),
        label: "Thumbs Down",
        testId: "import-feedback-banner-thumbs-down-button",
        onClick: ()=>{
            handleFeedbackClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'thumsDownButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close",
        testId: "import-feedback-banner-close-button",
        onClick: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'dismissButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
            handleDismissClick();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jQob7.FeedbackModal), {
        isOpen: isModalOpen,
        closeModal: ()=>setIsModalOpen(false),
        importSource: formattedSource,
        importDate: importDate,
        contentId: contentId,
        onFeedbackSubmit: handleDismissClick
    })));
};



var $4yKPM = parcelRequire("4yKPM");


var $hq2Sz = parcelRequire("hq2Sz");


var $kZEms = parcelRequire("kZEms");


var $8tF9d = parcelRequire("8tF9d");



var $cmBjr = parcelRequire("cmBjr");


var $lfmjq = parcelRequire("lfmjq");


var $83sfO = parcelRequire("83sfO");


var $3jwuS = parcelRequire("3jwuS");


var $gTyTP = parcelRequire("gTyTP");


var $efvKr = parcelRequire("efvKr");


var $398ES = parcelRequire("398ES");


var $hdxAi = parcelRequire("hdxAi");


var $cMKmt = parcelRequire("cMKmt");


var $1NBp8 = parcelRequire("1NBp8");


var $2VZOl = parcelRequire("2VZOl");


var $2xS8W = parcelRequire("2xS8W");


var $70pcM = parcelRequire("70pcM");


var $lrMxq = parcelRequire("lrMxq");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $fIKxq = parcelRequire("fIKxq");


var $jXhAV = parcelRequire("jXhAV");


var $fSC8h = parcelRequire("fSC8h");


var $8WQTF = parcelRequire("8WQTF");


var $kJNMt = parcelRequire("kJNMt");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $78QFu = parcelRequire("78QFu");


var $eSLr0 = parcelRequire("eSLr0");


var $juCeZ = parcelRequire("juCeZ");

/* NthUserOnboardingBannerComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 







var $8C5kA = parcelRequire("8C5kA");






var $fVUfS = parcelRequire("fVUfS");
















var $4PPzL = parcelRequire("4PPzL");


var $2YJkl = parcelRequire("2YJkl");


var $dBcar = parcelRequire("dBcar");





var $bZSO8 = parcelRequire("bZSO8");




const $90ee5598e42d1e39$export$2f4bef5ac2235525 = ({ size: size = 24 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.5834 12.4787V11.4679C40.5834 10.4416 39.7509 9.60904 38.7245 9.60904C37.6982 9.60904 36.8656 10.4416 36.8656 11.4679L36.8655 34.6931H40.5152V22.447C40.7101 22.3333 40.8416 22.1221 40.8416 21.8797V12.4787H40.5834Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36.8672 33.2949H40.517V36.517C40.517 37.5241 39.6983 38.3427 38.6912 38.3427C37.6841 38.3427 36.8655 37.5241 36.8655 36.517V33.2949H36.8672Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.0841 12.5274H39.5291V19.5895H40.0841V12.5274Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M30.1165 14.1508L31.4722 10.131L32.8278 14.1508H32.8301V37.264H31.9225V38.2101H30.973V37.264H30.116V14.1508H30.1165Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.0772 14.732H22.4275V38.4405H26.0772V14.732Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.4852 36.997H22.0186V38.5854H26.4852V36.997Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.0772 36.997H22.4275V38.4405H26.0772V36.997Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.4919 9.84648H25.0122V10.8868H26.8518L26.3526 16.3797H22.1635L21.666 10.8868H23.4919V9.84648Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.0772 14.7145H22.4275V16.3797H26.0772V14.7145Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.0303 10.5813V9.92496L17.1003 9.52176V10.5813H17.3271V11.9173C17.9504 12.208 18.3832 12.8407 18.3832 13.573V16.4634H18.3812V38.4405H14.7314V15.8194H14.7335V13.573C14.7335 12.8415 15.1653 12.2094 15.7876 11.9183V10.5813H16.0303Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.9373 26.2204C13.6598 26.3984 13.7331 26.5782 14.0438 26.4298C14.152 26.3774 14.262 26.3233 14.3754 26.2675C14.4802 26.2134 14.5884 26.1593 14.7123 26.1069C14.9532 26.0004 15.2098 25.8852 15.5013 25.7735C15.8294 25.6426 16.0354 25.5815 16.2186 25.5396C16.4002 25.4977 16.5608 25.4803 16.7842 25.5117C16.9727 25.5379 17.1821 25.6182 17.3637 25.7613C17.4056 25.7997 17.4492 25.8398 17.4928 25.88C17.533 25.9219 17.5644 25.9655 17.5993 26.0092C17.6569 26.1034 17.704 26.2029 17.7285 26.3111C",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.0262 24.3566C13.918 24.5207 14.0838 24.6272 14.2078 24.5067C14.3963 24.3304 14.5918 24.1349 14.8291 23.8731C15.091 23.5694 15.1294 23.4699 15.3161 23.2709C15.6268 22.9323 16.1923 22.3982 16.3285 22.2708C16.3494 22.2516 16.3686 22.2324 16.3861 22.2115C16.5153 22.0613 17.0825 21.4033 17.6027 20.864C17.9622 20.4765 18.1839 20.2356 18.2991 20.1117C18.5732 19.8149 18.7634 19.5811 18.9362 19.3349C19.0392 19.1883 18.8961 19.0941 18.7809 19.1936C18.5557 19.3856 18.334 19.5933 18.06 19.8883C",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.042 19.7396C13.9285 19.8495 14.0594 19.9944 14.1816 19.9298C14.3614 19.8356 14.5534 19.7291 14.7873 19.5773C15.0491 19.3957 15.0945 19.3189 15.2778 19.2072C15.585 19.01 16.133 18.7272 16.2657 18.6591C16.2849 18.6487 16.3041 18.6382 16.3215 18.626C16.4507 18.5352 17.018 18.1425 17.5276 17.8388C17.882 17.6154 18.1019 17.4775 18.2171 17.4042C18.4876 17.2314 18.6796 17.0882 18.8594 16.9294C18.9676 16.8317 18.8542 16.706 18.746 16.7531C18.5295 16.8491 18.3166 16.9591 18.0443 17.1284C17.9",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.102 10.5813H16.0303V11.5343H17.102V10.5813Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.51953 14.1734L9.34528 9.4258L11.1693 14.1734H7.51953Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.51953 14.1734H11.1693V34.693H7.51953V14.1734Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.51957 33.2949H11.1693V36.517C11.1693 37.5241 10.3507 38.3427 9.34357 38.3427C8.33644 38.3427 7.51782 37.5241 7.51782 36.517V33.2949H7.51957Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.99599 11.1206L9.34494 9.4258L8.69214 11.1206H9.99599Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5339 33.1553H7.15625V34.8309H11.5339V33.1553Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.1693 33.1553H7.51953V34.8309H11.1693V33.1553Z",
        fill: "#164B35"
    }));
};


/**
 * @graphql cc
 */ 



var $eSUdr = parcelRequire("eSUdr");





var $1uFM6 = parcelRequire("1uFM6");


var $7LI3Q = parcelRequire("7LI3Q");


var $5cryL = parcelRequire("5cryL");







var $jMyy4 = parcelRequire("jMyy4");





var $7Sm4c = parcelRequire("7Sm4c");


var $jNGt9 = parcelRequire("jNGt9");

// Mappings from team type to blueprint key
var $7c2911d3d6072871$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["ProductManagement"] = "Product management";
    Team["Marketing"] = "Marketing";
    Team["Design"] = "Design";
    Team["ProjectManagement"] = "Project management";
    Team["Operations"] = "Operations";
    Team["ITSupport"] = "IT support";
    Team["Finance"] = "Finance";
    Team["HumanResources"] = "Human resources";
    Team["Legal"] = "Legal";
    Team["Sales"] = "Sales";
    Team["SoftwareDevelopment"] = "Software development";
    Team["Default"] = "default";
    return Team;
}({});
const $7c2911d3d6072871$export$9be36dcb0276df0e = {
    ["Product management"]: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
    ["Marketing"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
    ["Design"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
    ["Project management"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    ["Operations"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
    ["IT support"]: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
    ["Finance"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    ["Human resources"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
    ["Legal"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    ["Sales"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
    ["Software development"]: 'flowchart',
    ["default"]: ''
};


function $d7f916a38b1d31f2$export$8715824c16ceeca0(error) {
    return (0, $1uFM6.isUnauthorizedError)(error) || (0, $7LI3Q.isUnauthorizedError)(error);
}
const $d7f916a38b1d31f2$export$f801dddbfe4eaae5 = ({ contentID: contentID })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_BANNER_DISMISSED,
        (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH,
        (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED
    ]);
    const { hasUserPublished: hasUserPublished, nthUserGSPagePath: nthUserGSPagePath, nthUserBannerDismissed: nthUserBannerDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isCorrectContentId = nthUserGSPagePath && (0, $jNGt9.extractContentIdFromUrl)(nthUserGSPagePath) === contentID;
    // Skip all side effects if user is not eligible
    const isUserEligible = !isOnboardingStateLoading && !onboardingStateError && !nthUserBannerDismissed && !hasUserPublished && nthUserGSPagePath && isCorrectContentId;
    // Query to get the team type of the user from identity service
    const { data: data, loading: isTeamTypeLoading, error: teamTypeError } = (0, $jMyy4.useQueryInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    (0, $eSUdr.gql)`query useNthUserOnboardingBannerGetTeamTypeQuery($userId:ID!){user:confluence_atlassianUser(id:$userId){team}}`, {
        variables: {
            userId: userId ?? ''
        },
        skip: !userId || !isUserEligible
    });
    const teamType = data?.user?.team;
    (0, $42omo.useEffect)(()=>{
        if (!isUserEligible) return;
        if (teamTypeError && $d7f916a38b1d31f2$export$8715824c16ceeca0(teamTypeError)) (0, $7Sm4c.markErrorAsHandled)(teamTypeError);
        else if (teamTypeError) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'nthUserGSPage',
                actionSubject: 'teamTypeFetching',
                action: 'failed',
                actionSubjectId: 'nthUserOnboardingBanner',
                attributes: {
                    error: teamTypeError?.message || teamTypeError || 'Unknown error'
                }
            }
        }).fire();
    }, [
        teamTypeError,
        createAnalyticsEvent,
        isUserEligible
    ]);
    // Query to get the template info from the blueprint key
    const blueprintKey = (0, $7c2911d3d6072871$export$9be36dcb0276df0e)[teamType ?? (0, $7c2911d3d6072871$export$3e5d0af8e738b082).Default];
    const { data: templateData, loading: isTemplateLoading, error: templateError } = (0, $jMyy4.useQueryInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    (0, $eSUdr.gql)`query useNthUserOnboardingBannerGetTemplateInfoQuery($blueprintKey:ID!){templateInfo(id:$blueprintKey){name templateType contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey}}`, {
        variables: {
            blueprintKey: blueprintKey
        },
        skip: !blueprintKey || !isUserEligible || teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).SoftwareDevelopment
    });
    (0, $42omo.useEffect)(()=>{
        if (!isUserEligible) return;
        if (templateError && $d7f916a38b1d31f2$export$8715824c16ceeca0(templateError)) (0, $7Sm4c.markErrorAsHandled)(templateError);
        else if (templateError) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'nthUserGSPage',
                actionSubject: 'templateFetching',
                action: 'failed',
                actionSubjectId: 'nthUserOnboardingBanner',
                attributes: {
                    error: templateError?.message || templateError || 'Unknown error'
                }
            }
        }).fire();
    }, [
        templateError,
        createAnalyticsEvent,
        isUserEligible
    ]);
    const { templateInfo: templateInfo } = templateData || {};
    const { name: templateName } = templateInfo || {};
    const blueprintName = (0, $42omo.useMemo)(()=>{
        if (!isUserEligible) return '';
        if (teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).SoftwareDevelopment) return blueprintKey;
        if (teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).Operations) return 'standard operating procedure';
        return (templateName ?? '').toLowerCase();
    }, [
        isUserEligible,
        teamType,
        templateName,
        blueprintKey
    ]);
    const isLoading = isTeamTypeLoading || isTemplateLoading;
    return {
        isUserEligible: isUserEligible,
        isLoading: isLoading,
        blueprintName: blueprintName,
        teamType: teamType,
        templateToCreate: templateInfo
    };
};



const $627671e2381ceaa8$var$roundedBoxStyles = {
    root: "_2rko1mok _1yt4u2gc _1h6dvbh5 _16qst7xp _1bsb1osq _p12f9gu9"
};
const $627671e2381ceaa8$var$observerStyles = {
    root: "_4t3it94y _1bsb1osq _3um015vq _lcxvglyw"
};
const $627671e2381ceaa8$var$outerContainerStyles = {
    root: "_1e0c1txw _1bah1h6o"
};
const $627671e2381ceaa8$var$innerContainerStyles = {
    locked: "_kqswh2mm _lcxv1wug _1e0c1txw _1bah1h6o _1bsb1osq _otyrpxbi _19pkpxbi",
    floating: "_kqsw1n9t _94n5pxbi _lcxv1wug _1e0c1txw _1bah1h6o _1bsb1osq _otyru2gc"
};
const $627671e2381ceaa8$var$linkPressableStyles = {
    root: "_19itglyw _1yt4ze3t _bfhk19ip _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af"
};
const $627671e2381ceaa8$var$i18n = (0, $cgtv4.defineMessages)({
    nthUserOnboardingBannerTitle: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.title",
        defaultMessage: "Next up: start creating"
    },
    nthUserOnboardingBannerAction: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.action",
        defaultMessage: "Try a {blueprintName} template"
    },
    nthUserOnboardingBannerActionFallback: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.action-fallback",
        defaultMessage: "Create a page"
    },
    nthUserOnboardingBannerDismiss: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $627671e2381ceaa8$var$DELAY_TIMEOUT = 8000;
const $627671e2381ceaa8$var$NthUserOnboardingBannerComponentInternal = ({ contentID: contentID, spaceKey: spaceKey })=>{
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [isLocked, setIsLocked] = (0, $42omo.useState)(false);
    const observerRef = (0, $42omo.useRef)(null);
    const intersectionObserverRef = (0, $42omo.useRef)(null);
    const isLockedRef = (0, $42omo.useRef)(false);
    const hasBeenTriggered = (0, $42omo.useRef)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const createContentFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isUserEligible: isUserEligible, isLoading: isLoading, blueprintName: blueprintName, teamType: teamType, templateToCreate: templateToCreate } = (0, $d7f916a38b1d31f2$export$f801dddbfe4eaae5)({
        contentID: contentID
    }); // Show banner after delay
    (0, $42omo.useEffect)(()=>{
        if (!isUserEligible) return;
        isLockedRef.current = isLocked;
        const delayTimeout = setTimeout(()=>{
            setIsVisible(true);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'viewNthUserOnboardingBanner'
                }
            }).fire();
        }, $627671e2381ceaa8$var$DELAY_TIMEOUT);
        return ()=>clearTimeout(delayTimeout);
    }, [
        isUserEligible,
        isLocked,
        createAnalyticsEvent
    ]); // Intersection observer for banner positioning
    (0, $42omo.useEffect)(()=>{
        if (!isVisible || !isUserEligible) return;
        const targetElement = observerRef.current;
        if (!targetElement) return;
        let pollInterval = null;
        const checkPosition = ()=>{
            const targetRect = targetElement.getBoundingClientRect();
            const isTargetWellBelowViewport = targetRect.top > window.innerHeight + 100;
            if (isTargetWellBelowViewport && isLockedRef.current) {
                setIsLocked(false);
                hasBeenTriggered.current = false;
                if (pollInterval) {
                    clearInterval(pollInterval);
                    pollInterval = null;
                }
            }
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !hasBeenTriggered.current) {
                    setIsLocked(true);
                    hasBeenTriggered.current = true;
                    pollInterval = setInterval(checkPosition, 100);
                }
            });
        };
        intersectionObserverRef.current = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '0px',
            threshold: 0
        });
        intersectionObserverRef.current.observe(targetElement);
        return ()=>{
            if (intersectionObserverRef.current) intersectionObserverRef.current.disconnect();
            if (pollInterval) clearInterval(pollInterval);
        };
    }, [
        isVisible,
        isUserEligible
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setIsVisible(false);
        setOnboardingState({
            key: (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_BANNER_DISMISSED,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'nthUserGSPage',
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'nthUserOnboardingBanner'
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    const handleTemplateClick = (0, $42omo.useCallback)(()=>{
        try {
            if (spaceKey) {
                if (templateToCreate) createContentFromTemplate(templateToCreate, spaceKey, {
                    openContentInNewTab: true
                });
                else if (teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).SoftwareDevelopment) {
                    // If the user is in a software development team, we need to create a flowchart template - separate flow
                    const softwareTemplateCreationLink = (0, $bZSO8.buildCreationLink)({
                        contentType: 'whiteboard',
                        source: 'nthUserOnboardingBanner',
                        spaceKey: spaceKey,
                        insertTemplateWithKey: 'flow-chart',
                        openTemplatePicker: false
                    });
                    window.open(softwareTemplateCreationLink, '_blank');
                } else {
                    // default to create a blank page - no team type or template available
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: 'page',
                        source: 'nthUserOnboardingBanner',
                        spaceKey: spaceKey
                    });
                    window.open(createUrl, '_blank');
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'nthUserGSPage',
                        action: 'clicked',
                        actionSubject: 'banner',
                        actionSubjectId: 'nthUserOnboardingBanner'
                    }
                }).fire();
            }
            handleDismiss();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'nthUserGSPage',
                    action: 'failed',
                    actionSubject: 'template creation',
                    actionSubjectId: 'nthUserOnboardingBanner',
                    attributes: {
                        error: error?.message || error || 'Unknown error'
                    }
                }
            }).fire();
            handleDismiss();
        }
    }, [
        createContentFromTemplate,
        createAnalyticsEvent,
        handleDismiss,
        spaceKey,
        templateToCreate,
        teamType
    ]);
    if (!isVisible || !isUserEligible || isLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: observerRef,
        xcss: $627671e2381ceaa8$var$observerStyles['root']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $627671e2381ceaa8$var$outerContainerStyles['root'],
        "data-vc": "page-layout-nth-user-onboarding-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $627671e2381ceaa8$var$innerContainerStyles[isLocked ? 'locked' : 'floating']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $627671e2381ceaa8$var$roundedBoxStyles['root'],
        backgroundColor: "color.background.information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90ee5598e42d1e39$export$2f4bef5ac2235525), {
        size: 50
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $627671e2381ceaa8$var$i18n.nthUserOnboardingBannerTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: handleTemplateClick,
        xcss: $627671e2381ceaa8$var$linkPressableStyles['root']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.link"
    }, blueprintName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$627671e2381ceaa8$var$i18n.nthUserOnboardingBannerAction,
        values: {
            blueprintName: blueprintName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $627671e2381ceaa8$var$i18n.nthUserOnboardingBannerActionFallback))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleDismiss,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), iconProps),
        label: formatMessage($627671e2381ceaa8$var$i18n.nthUserOnboardingBannerDismiss),
        isTooltipDisabled: false
    })))))));
};
const $627671e2381ceaa8$export$a4224605ab1026cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($627671e2381ceaa8$var$NthUserOnboardingBannerComponentInternal, props));




















const $bd6002357c1db080$export$d42c6c42be666145 = ({ contentId: contentId = '', skip: skip = false } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH,
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED
    ], skip);
    const deserializedState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const nthUserOnboardingPageViewed = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_PAGE_VIEWED];
    const nthUserGSPage = deserializedState[0, $dBcar.IMPROVED_GET_STARTED_NTH_USER_PATH];
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate')) return;
        if (!onboardingStateData || onboardingStateError || onboardingStateLoading) return;
        if (nthUserGSPage && (0, $jNGt9.extractContentIdFromUrl)(nthUserGSPage) === contentId) {
            if (!nthUserOnboardingPageViewed) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'NthUserGettingStartedPage'
                    }
                }).fire();
                setOnboardingState({
                    key: (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED,
                    value: 'true'
                });
            }
        }
    }, [
        contentId,
        createAnalyticsEvent,
        onboardingStateData,
        onboardingStateError,
        onboardingStateLoading,
        nthUserGSPage,
        nthUserOnboardingPageViewed,
        setOnboardingState,
        skip
    ]);
};












var $JCGnt = parcelRequire("JCGnt");


const $4d7d073c1c91ca91$var$useLazyAmplitudeInit = ()=>{
    return (0, $42omo.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3ql08"));
        return module.AmplitudeSessionReplay.init();
    }, []);
};

const $4d7d073c1c91ca91$var$useLazyAmplitudeStop = ()=>{
    return (0, $42omo.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3ql08"));
        return module.AmplitudeSessionReplay.stop();
    }, []);
};
const $4d7d073c1c91ca91$export$7ac5f7e6449ca924 = ({ skip: skip = false, timeoutMs: timeoutMs = 180000 // 3 minutes default
 } = {})=>{
    const amplitudeInit = $4d7d073c1c91ca91$var$useLazyAmplitudeInit();
    const amplitudeStop = $4d7d073c1c91ca91$var$useLazyAmplitudeStop();
    const timeoutRef = (0, $42omo.useRef)();
    const isInitializedRef = (0, $42omo.useRef)(false);
    const analyticsEventFiredRef = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isNewUser: isNewUser, loading: isLoadingNewUser } = (0, $JCGnt.useIsNewUser)({}, skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate'));
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        // Initialize amplitude
        amplitudeInit();
        isInitializedRef.current = true;
        // Set timeout to stop after specified time
        timeoutRef.current = setTimeout(()=>{
            amplitudeStop();
            isInitializedRef.current = false;
        }, timeoutMs);
        // Cleanup function
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        skip,
        amplitudeInit,
        amplitudeStop,
        timeoutMs
    ]);
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate') || !isInitializedRef.current || analyticsEventFiredRef.current || isLoadingNewUser) return;
        if (isNewUser) {
            //Use this analytics event to add extra attributes so it can be filtered in Amplitude
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'triggered',
                    actionSubject: 'amplitudeSessionReplay',
                    source: 'confluenceAmplitudeSessionReplay',
                    attributes: {
                        isNewUser: true
                    }
                }
            }).fire();
            analyticsEventFiredRef.current = true;
        }
    }, [
        skip,
        isNewUser,
        createAnalyticsEvent,
        isLoadingNewUser
    ]);
    // Cleanup effect that always runs on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        amplitudeStop
    ]);
    // Handle pagehide to stop amplitude session replay when page closes
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        const handlePageHide = ()=>{
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
        window.addEventListener('pagehide', handlePageHide);
        return ()=>{
            window.removeEventListener('pagehide', handlePageHide);
        };
    }, [
        skip,
        amplitudeStop
    ]);
};



var $dGhsu = parcelRequire("dGhsu");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $f7fdcf7379ee3b47$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'flex',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderColor: 'color.border'
});
const $f7fdcf7379ee3b47$export$2e0a83ec2e27ecbb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { testId: testId } = t0;
    let t1;
    if ($[0] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f7fdcf7379ee3b47$var$dividerStyles,
            testId: testId
        });
        $[0] = testId;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $f7fdcf7379ee3b47$var$dividerStyles,
        testId: testId
    });






const $889eab36c217c00c$export$bdd4a5944172b352 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "kTgHc",
    name: "SatisfactionSurveysLoader",
    loader: async ()=>(await (parcelRequire("8E6no"))).SatisfactionSurveys
});



var $aXika = parcelRequire("aXika");














var $j1Ss3 = parcelRequire("j1Ss3");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $04e9M = parcelRequire("04e9M");





var $2i3To = parcelRequire("2i3To");








var $isEtk = parcelRequire("isEtk");





var $deTj5 = parcelRequire("deTj5");


var $7zgzO = parcelRequire("7zgzO");


var $hrEV9 = parcelRequire("hrEV9");





var $aJv6Q = parcelRequire("aJv6Q");





var $ftXPY = parcelRequire("ftXPY");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");




const $1f8c76250771e531$var$pageCommentWrapperStyles = null;
const $1f8c76250771e531$var$sendKeyboardShortcutAnalytics = (shortcut)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
        analyticsClient.sendUIEvent({
            source: 'viewPage',
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: 'createComment',
            attributes: {
                key: shortcut
            }
        });
    });
}; /**
    * @deprecated This component is deprecated and will be removed in a future version.
    * It is used to render legacy page comments but is no longer needed as part of modernization.
    */ 
const $1f8c76250771e531$var$LazyLoadablePageComments = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { children: children, isContentReady: isContentReady, shouldLazyLoad: shouldLazyLoad, renderPlaceholder: t1, loadPageCommentsCallback: t2, isCommentsReady: isCommentsReady, totalCount: totalCount } = t0;
    const renderPlaceholder = t1 === undefined ? undefined : t1;
    const loadPageCommentsCallback = t2 === undefined ? undefined : t2;
    const wrapperRef = (0, $42omo.useRef)(null);
    const observerRef = (0, $42omo.useRef)(null);
    const [loadPageComments, setLoadPageComments] = (0, $42omo.useState)(!shouldLazyLoad);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isCommentsPanelShown = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel;
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (Boolean(undefined) || window.__SSR_RENDERED__) && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder");
        $[0] = t3;
    } else t3 = $[0];
    const isCommentPreloadedForSSR = t3;
    let t4;
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            observerRef.current = new IntersectionObserver((t6)=>{
                const [entry] = t6;
                if (entry.isIntersecting) {
                    setLoadPageComments(true);
                    observerRef.current?.disconnect();
                }
            });
            return ()=>{
                observerRef.current?.disconnect();
            };
        };
        t5 = [];
        $[1] = t4;
        $[2] = t5;
    } else {
        t4 = $[1];
        t5 = $[2];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[3] !== isContentReady || $[4] !== loadPageComments) {
        t6 = ()=>{
            if (wrapperRef.current && !loadPageComments && isContentReady) observerRef.current?.observe(wrapperRef.current);
        };
        t7 = [
            loadPageComments,
            isContentReady
        ];
        $[3] = isContentReady;
        $[4] = loadPageComments;
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[7] !== loadPageComments || $[8] !== loadPageCommentsCallback) {
        t8 = ()=>{
            if (loadPageComments) loadPageCommentsCallback?.();
        };
        t9 = [
            loadPageComments,
            loadPageCommentsCallback
        ];
        $[7] = loadPageComments;
        $[8] = loadPageCommentsCallback;
        $[9] = t8;
        $[10] = t9;
    } else {
        t8 = $[9];
        t9 = $[10];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    if ($[11] !== isCommentsPanelShown || $[12] !== loadPageComments) {
        t10 = loadPageComments || isCommentsPanelShown && (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[11] = isCommentsPanelShown;
        $[12] = loadPageComments;
        $[13] = t10;
    } else t10 = $[13];
    const shouldRenderPageComments = t10;
    let t11;
    if ($[14] !== isCommentsReady || $[15] !== setQueryParams) {
        t11 = (e)=>{
            e.preventDefault();
            const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
            if (!isCommentsReady) {
                setQueryParams({
                    showCommentArea: "true"
                });
                wrapperRef.current?.scrollIntoView && wrapperRef.current?.scrollIntoView();
            } else window.dispatchEvent(new Event("openPageCommentEditor"));
            $1f8c76250771e531$var$sendKeyboardShortcutAnalytics(shortcut);
        };
        $[14] = isCommentsReady;
        $[15] = setQueryParams;
        $[16] = t11;
    } else t11 = $[16];
    const openCommentEditorShortcutCb = t11;
    let t12;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $gMc0m.default)([
            "_kqswh2mm _1pbyidpf"
        ]);
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== openCommentEditorShortcutCb) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
            listener: (e_0)=>openCommentEditorShortcutCb(e_0)
        });
        $[18] = openCommentEditorShortcutCb;
        $[19] = t13;
    } else t13 = $[19];
    let t14;
    if ($[20] !== children || $[21] !== renderPlaceholder || $[22] !== shouldRenderPageComments || $[23] !== totalCount) {
        t14 = isCommentPreloadedForSSR && totalCount === 0 || shouldRenderPageComments ? children : renderPlaceholder?.();
        $[20] = children;
        $[21] = renderPlaceholder;
        $[22] = shouldRenderPageComments;
        $[23] = totalCount;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== t13 || $[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testId": "page-comment-wrapper",
            ref: wrapperRef,
            className: t12
        }, t13, t14);
        $[25] = t13;
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    return t15;
} : ({ children: children, isContentReady: isContentReady, shouldLazyLoad: shouldLazyLoad, renderPlaceholder: renderPlaceholder, loadPageCommentsCallback: loadPageCommentsCallback, isCommentsReady: isCommentsReady, totalCount: totalCount })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const observerRef = (0, $42omo.useRef)(null); // load comments immediately if not lazy load, otherwise wait until it is in the viewport
    const [loadPageComments, setLoadPageComments] = (0, $42omo.useState)(!shouldLazyLoad);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isCommentsPanelShown = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel;
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const isCommentPreloadedForSSR = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    (Boolean(undefined) || window.__SSR_RENDERED__) && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder');
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        observerRef.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                // show page comments when the wrapper is in viewport
                setLoadPageComments(true);
                observerRef.current?.disconnect();
            }
        }); // Remove the observer as soon as the component is unmounted
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (wrapperRef.current && !loadPageComments && isContentReady) // attach intersection observer after content is ready
        observerRef.current?.observe(wrapperRef.current);
    }, [
        loadPageComments,
        isContentReady
    ]);
    (0, $42omo.useEffect)(()=>{
        if (loadPageComments) loadPageCommentsCallback?.();
    }, [
        loadPageComments,
        loadPageCommentsCallback
    ]); // render placeholder only in SSR
    const shouldRenderPageComments = loadPageComments || isCommentsPanelShown && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault(); // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (!isCommentsReady) {
            setQueryParams({
                showCommentArea: 'true'
            }); //This will scroll to and load the page comments section if its not available (e.g. on long pages)
            wrapperRef.current?.scrollIntoView && wrapperRef.current?.scrollIntoView();
        } else window.dispatchEvent(new Event('openPageCommentEditor'));
        $1f8c76250771e531$var$sendKeyboardShortcutAnalytics(shortcut);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testId": "page-comment-wrapper",
        ref: wrapperRef,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1pbyidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e_0)=>openCommentEditorShortcutCb(e_0)
    }), isCommentPreloadedForSSR && totalCount === 0 || shouldRenderPageComments ? children : renderPlaceholder?.());
};
const $1f8c76250771e531$var$ViewPageFooterCommentsComponent = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { contentId: contentId, classicComments: classicComments, loadingPriority: loadingPriority, hasReactions: hasReactions } = t0;
    const [state] = (0, $isEtk.useContentState)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId,
            offset: "",
            first: (0, $2i3To.DEFAULT_LIMIT)
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = hasReactions && window.__SSR_RENDERED__ && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder") ? "cache-first" : "cache-and-network";
    const t3 = !contentId;
    let t4;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t4 = {
            variables: t1,
            fetchPolicy: t2,
            skip: t3
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { data: data, error: error } = (0, $j1Ss3.useQuery)(hasReactions ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), t4);
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    let totalCount;
    if ($[6] !== data) {
        if (data?.comments && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder")) totalCount = data.comments.totalCount;
        $[6] = data;
        $[7] = totalCount;
    } else totalCount = $[7];
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t5;
    if ($[8] !== getQueryParams) {
        t5 = getQueryParams();
        $[8] = getQueryParams;
        $[9] = t5;
    } else t5 = $[9];
    const { focusedCommentId: focusedCommentId, replyToComment: replyToComment, showCommentArea: showCommentArea, editComment: editComment, commentId: commentId } = t5;
    const isFocusedComment = Boolean(focusedCommentId || replyToComment || showCommentArea || editComment === "true" && commentId);
    const [isCommentsReady, setIsCommentsReady] = (0, $42omo.useState)(false);
    let t6;
    if ($[10] !== contentId || $[11] !== experienceTracker || $[12] !== isFocusedComment) {
        t6 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    isConditionalRenderingOn: true,
                    isFocusedComment: isFocusedComment,
                    editor: "FABRIC",
                    contentId: contentId
                }
            });
        };
        $[10] = contentId;
        $[11] = experienceTracker;
        $[12] = isFocusedComment;
        $[13] = t6;
    } else t6 = $[13];
    const startExperienceTracker = t6;
    let t7;
    if ($[14] !== state.isContentReady || $[15] !== totalCount) {
        t7 = ()=>{
            if (totalCount === 0 && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder")) return null;
            const showPlaceholder = Boolean(undefined) || window.__SSR_RENDERED__ || state.isContentReady;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
                showPlaceholder: showPlaceholder
            });
        };
        $[14] = state.isContentReady;
        $[15] = totalCount;
        $[16] = t7;
    } else t7 = $[16];
    totalCount;
    const renderCommentPlaceholder = t7;
    const t8 = !isFocusedComment;
    let t9;
    if ($[17] !== isCommentsReady || $[18] !== renderCommentPlaceholder) {
        t9 = !(0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder") && !isCommentsReady && renderCommentPlaceholder();
        $[17] = isCommentsReady;
        $[18] = renderCommentPlaceholder;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>setIsCommentsReady(true);
        $[20] = t10;
    } else t10 = $[20];
    const t11 = loadingPriority || (0, $398ES.LoadingPriority).PAINT;
    let t12;
    if ($[21] !== classicComments || $[22] !== contentId || $[23] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hrEV9.CommentsSectionLoader), {
            contentId: contentId,
            classicComments: classicComments,
            handlePageCommentsRender: t10,
            loadingPriority: t11
        });
        $[21] = classicComments;
        $[22] = contentId;
        $[23] = t11;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== t12 || $[26] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t9, t12);
        $[25] = t12;
        $[26] = t9;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== isCommentsReady || $[29] !== renderCommentPlaceholder || $[30] !== startExperienceTracker || $[31] !== state.isContentReady || $[32] !== t13 || $[33] !== t8 || $[34] !== totalCount) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1f8c76250771e531$var$LazyLoadablePageComments, {
            shouldLazyLoad: t8,
            isContentReady: state.isContentReady,
            renderPlaceholder: renderCommentPlaceholder,
            loadPageCommentsCallback: startExperienceTracker,
            isCommentsReady: isCommentsReady,
            totalCount: totalCount
        }, t13);
        $[28] = isCommentsReady;
        $[29] = renderCommentPlaceholder;
        $[30] = startExperienceTracker;
        $[31] = state.isContentReady;
        $[32] = t13;
        $[33] = t8;
        $[34] = totalCount;
        $[35] = t14;
    } else t14 = $[35];
    return t14;
} : ({ contentId: contentId, classicComments: classicComments, loadingPriority: loadingPriority, hasReactions: hasReactions })=>{
    const [state] = (0, $isEtk.useContentState)(); /* Preload CommentsSectionQuery - We preload CommentsSectionQuery as part of next/packages/query-preloaders/src/index.ts,
                                        but its bestEffort Preloading - meaning if it exceeds the threshold it wont wait for query to finish
                                        Adding preloading here as well to ensure data is ready once user scrolls*/ 
    const { data: data, error: error } = (0, $j1Ss3.useQuery)(hasReactions ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: (0, $2i3To.DEFAULT_LIMIT)
        },
        fetchPolicy: hasReactions && window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : 'cache-and-network',
        skip: !contentId
    }); /*  Marking all graphql errors here as handled since we are only preloading query. The CommentsSectionFabric component
         where the query data is used has exhaustive error handling*/ 
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    let totalCount; // data will be populated on first render only if SSR preloading is successful. In this scenario,
    // the totalCount will be either 0 or some number. For all other cases (either FG is disabled or FG is enabled but there
    // was an issue with preloading which resulted in no cached data), totalCount will be undefined
    if (data?.comments && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder')) totalCount = data.comments.totalCount;
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { focusedCommentId: focusedCommentId, replyToComment: replyToComment, showCommentArea: showCommentArea, editComment: editComment, commentId: commentId } = getQueryParams(); /* check for query params - If anyone of these are true just load Page comments */ 
    const isFocusedComment = Boolean(focusedCommentId || replyToComment || showCommentArea || editComment === 'true' && commentId);
    const [isCommentsReady, setIsCommentsReady] = (0, $42omo.useState)(false);
    const startExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
            attributes: {
                isConditionalRenderingOn: true,
                isFocusedComment: isFocusedComment,
                editor: 'FABRIC',
                contentId: contentId
            }
        });
    }, [
        experienceTracker,
        isFocusedComment,
        contentId
    ]); /* Display comment Placeholder if isContentReady is true - Waiting for content to render to
                                                        display placholder since at times it will display the placeholder towards middle of screen
                                                        and then get pushed down*/ 
    const renderCommentPlaceholder = (0, $42omo.useCallback)(()=>{
        // if the preloading FG is enabled AND there are no comments, there is no need to return a placeholder
        if (totalCount === 0 && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder')) return null;
        const showPlaceholder = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || window.__SSR_RENDERED__ || state.isContentReady;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
            showPlaceholder: showPlaceholder
        });
    }, [
        state.isContentReady,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1f8c76250771e531$var$LazyLoadablePageComments, {
        shouldLazyLoad: !isFocusedComment,
        isContentReady: state.isContentReady,
        renderPlaceholder: renderCommentPlaceholder,
        loadPageCommentsCallback: startExperienceTracker,
        isCommentsReady: isCommentsReady,
        totalCount: totalCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, // Important! Here, the renderCommentPlaceholder() must match the renderPlaceholder
    // in LazyLoadPageComments to ensure the initial hydration matches the SSR render result
    !(0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') && !isCommentsReady && renderCommentPlaceholder(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hrEV9.CommentsSectionLoader), {
        contentId: contentId,
        classicComments: classicComments,
        handlePageCommentsRender: ()=>setIsCommentsReady(true),
        loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT
    })));
});
const $1f8c76250771e531$export$3469ece96a08b09e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COLLABORATION
})($1f8c76250771e531$var$ViewPageFooterCommentsComponent);












var $xQxzY = parcelRequire("xQxzY");

















var $liGyh = parcelRequire("liGyh");


var $39nIX = parcelRequire("39nIX");


var $beAZw = parcelRequire("beAZw");


var $8uhVX = parcelRequire("8uhVX");


var $8Ya23 = parcelRequire("8Ya23");


var $3s9yq = parcelRequire("3s9yq");


var $e4o8D = parcelRequire("e4o8D");

const $9450efcd5fbf758a$export$9fdf0be90cc81aa6 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { contentId: contentId, loadingPriority: loadingPriority, isFabricPage: isFabricPage } = t0;
    const { editCommentId: editCommentId, replyToCommentId: replyToCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] !== getQueryParams) {
        t1 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const { focusedCommentId: queryParamsFocusedCommentId } = t1;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const focusedCommentId = queryParamsFocusedCommentId ? queryParamsFocusedCommentId : undefined;
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            pageId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = !contentId || isFabricPage;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { error: error } = (0, $xQxzY.useQuery)((0, $3s9yq.InlineCommentsQuery), t4);
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    let t5;
    if ($[7] !== contentId || $[8] !== focusedCommentId) {
        t5 = {
            commentId: focusedCommentId,
            contentId: contentId
        };
        $[7] = contentId;
        $[8] = focusedCommentId;
        $[9] = t5;
    } else t5 = $[9];
    const t6 = !(contentId && focusedCommentId);
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
        t7 = {
            variables: t5,
            fetchPolicy: "cache-first",
            skip: t6
        };
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    const { data: data, error: focusedCommentError } = (0, $xQxzY.useQuery)((0, $8Ya23.FocusedInlineCommentQuery), t7);
    if (focusedCommentError && (0, $1uFM6.isUnauthorizedError)(focusedCommentError)) (0, $7Sm4c.markErrorAsHandled)(focusedCommentError);
    const isFocusedInlineComment = Boolean(data?.comments?.nodes?.[0]?.isInlineComment);
    const { firstHighlightClicked: firstHighlightClicked, shouldDisplaySidebar: shouldDisplaySidebar } = (0, $9jl6v.useInlineCommentsContext)();
    const { toggleSidebar: toggleSidebar } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    let t8;
    let t9;
    if ($[13] !== editCommentId || $[14] !== firstHighlightClicked || $[15] !== isFocusedInlineComment || $[16] !== replyToCommentId || $[17] !== shouldDisplaySidebar || $[18] !== toggleSidebar) {
        t8 = ()=>{
            if (window.__SSR_RENDERED__ && isFocusedInlineComment || isFocusedInlineComment || replyToCommentId || editCommentId && shouldDisplaySidebar || firstHighlightClicked && shouldDisplaySidebar) toggleSidebar(true);
        };
        t9 = [
            isFocusedInlineComment,
            replyToCommentId,
            editCommentId,
            firstHighlightClicked,
            toggleSidebar,
            shouldDisplaySidebar
        ];
        $[13] = editCommentId;
        $[14] = firstHighlightClicked;
        $[15] = isFocusedInlineComment;
        $[16] = replyToCommentId;
        $[17] = shouldDisplaySidebar;
        $[18] = toggleSidebar;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, $42omo.useEffect)(t8, t9);
    if (renderServerPlaceholder && isFocusedInlineComment) {
        let t10;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null);
            $[21] = t10;
        } else t10 = $[21];
        return t10;
    }
    let t10;
    if ($[22] !== renderServerPlaceholder) {
        t10 = renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
        $[22] = renderServerPlaceholder;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== contentId || $[25] !== focusedCommentId || $[26] !== isFabricPage || $[27] !== loadingPriority || $[28] !== shouldDisplaySidebar) {
        t11 = shouldDisplaySidebar && !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39nIX.InlineCommentsLoader), {
            pageId: contentId,
            isFabricPage: Boolean(isFabricPage),
            loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT,
            focusedCommentId: focusedCommentId
        });
        $[24] = contentId;
        $[25] = focusedCommentId;
        $[26] = isFabricPage;
        $[27] = loadingPriority;
        $[28] = shouldDisplaySidebar;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t10, t11);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
} : ({ contentId: contentId, loadingPriority: loadingPriority, isFabricPage: isFabricPage })=>{
    const { editCommentId: editCommentId, replyToCommentId: replyToCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    //COMMENTS-158 - focusedCommentId is getting retrieved here instead of using useInlineCommentQueryParams because the function is module replaced in SSR and the logic and does not work on SSR pages
    const { focusedCommentId: queryParamsFocusedCommentId } = getQueryParams();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const focusedCommentId = queryParamsFocusedCommentId ? queryParamsFocusedCommentId : undefined;
    /**
   * Preload InlineCommentsQuery - We preload InlineCommentsQuery as part of next/packages/query-preloaders/src/index.ts,
   * but its bestEffort Preloading - meaning if it exceeds the threshold it wont wait for query to finish
   * Adding preloading here as well to ensure data is ready before first highlight click
   */ const { error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $3s9yq.InlineCommentsQuery), {
        variables: {
            pageId: contentId
        },
        skip: !contentId || isFabricPage
    });
    /**
   * Marking all graphql errors here as handled since we are only preloading query.
   * The InlineComments component where the query data is used has exhaustive error handling
   */ if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, error: focusedCommentError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8Ya23.FocusedInlineCommentQuery), {
        variables: {
            commentId: focusedCommentId,
            contentId: contentId
        },
        fetchPolicy: 'cache-first',
        skip: !(contentId && focusedCommentId)
    });
    if (focusedCommentError && (0, $1uFM6.isUnauthorizedError)(focusedCommentError)) (0, $7Sm4c.markErrorAsHandled)(focusedCommentError);
    /* Only load Inline Comments when focusedCommentId is a Inline comment*/ const isFocusedInlineComment = Boolean(data?.comments?.nodes?.[0]?.isInlineComment);
    const { firstHighlightClicked: firstHighlightClicked, shouldDisplaySidebar: shouldDisplaySidebar } = (0, $9jl6v.useInlineCommentsContext)();
    const { toggleSidebar: toggleSidebar } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    (0, $42omo.useEffect)(()=>{
        // Remaining query based scenarios that require inline comments to load immediately
        if (window.__SSR_RENDERED__ && isFocusedInlineComment || isFocusedInlineComment || replyToCommentId || editCommentId && shouldDisplaySidebar || firstHighlightClicked && shouldDisplaySidebar) toggleSidebar(true);
    }, [
        isFocusedInlineComment,
        replyToCommentId,
        editCommentId,
        firstHighlightClicked,
        toggleSidebar,
        shouldDisplaySidebar
    ]);
    /* Focused Comment SSR */ if (renderServerPlaceholder && isFocusedInlineComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null);
    /**
   * On initial page load, shouldDisplaySidebar will usually be false allowing us to
   * avoid loading inline comments unless needed. The three scenarios where we would
   * explicitly load are:
   * 1. Query Parameters
   * 2. Click on a highlight
   * 3. Create an inline comment
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null), shouldDisplaySidebar && !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39nIX.InlineCommentsLoader), {
        pageId: contentId,
        isFabricPage: Boolean(isFabricPage),
        loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT,
        focusedCommentId: focusedCommentId
    }));
});


















var $2ttXz = parcelRequire("2ttXz");


var $ke5Nx = parcelRequire("ke5Nx");


var $1NF8X = parcelRequire("1NF8X");


var $bFPHx = parcelRequire("bFPHx");










// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36f4246476d285d5$var$ViewPageReactionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4r2fv _1reoewfl _18m9ewfl _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _n7zlia51 _1e0c1txw _4cvr1y6m _1bah1yb4 _11rm1hrf _1bsb1osq _p12fn7od _1p4q1ssb _1l0tx19p _3u9vusic _1aor1o8l",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4r2fv _1reoewfl _18m9ewfl _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _n7zlia51 _1e0c1txw _4cvr1y6m _1bah1yb4 _11rm1hrf _1bsb1osq _p12fn7od _1p4q1ssb _1l0tx19p _3u9vusic _1aor1o8l",
            __cmplp.className
        ])
    });
});
const $36f4246476d285d5$export$b2a33efe33addcf5 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { hasReactions: hasReactions, contentType: contentType, contentId: contentId, spaceId: spaceId, contentSubType: contentSubType } = t0;
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentSubType || $[2] !== contentType || $[3] !== edition || $[4] !== focusedPageReactionsId || $[5] !== spaceId) {
        t1 = ()=>{
            if (contentType && spaceId) {
                const ReactionsLoader = Boolean(focusedPageReactionsId) ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $1NF8X.ReactionsLoader);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ReactionsLoader, {
                    contentId: contentId,
                    location: contentType,
                    containerId: spaceId,
                    containerType: (0, $2ttXz.ReactionContainerType).SPACE,
                    contentSubType: contentSubType,
                    customAnalyticsAttributes: {
                        edition: edition,
                        reactionsPlacement: "bottom"
                    }
                });
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
        };
        $[0] = contentId;
        $[1] = contentSubType;
        $[2] = contentType;
        $[3] = edition;
        $[4] = focusedPageReactionsId;
        $[5] = spaceId;
        $[6] = t1;
    } else t1 = $[6];
    const displayReactions = t1;
    if (renderServerPlaceholder) {
        let t2;
        if ($[7] !== hasReactions || $[8] !== isReactionsEnabled) {
            t2 = isReactionsEnabled && hasReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
                useAccuratePills: true
            });
            $[7] = hasReactions;
            $[8] = isReactionsEnabled;
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36f4246476d285d5$var$ViewPageReactionsContainer, {
                id: "view-page-reactions-container",
                "data-vc": "view-page-reactions-container-server-placeholder",
                "data-testid": "view-page-reactions-container",
                "data-test-id": "view-page-reactions-container"
            }, t2);
            $[10] = t2;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    } else if (state?.isContentReady) {
        let t2;
        if ($[12] !== displayReactions || $[13] !== hasReactions || $[14] !== isReactionsEnabled) {
            t2 = hasReactions && isReactionsEnabled && displayReactions();
            $[12] = displayReactions;
            $[13] = hasReactions;
            $[14] = isReactionsEnabled;
            $[15] = t2;
        } else t2 = $[15];
        let t3;
        if ($[16] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36f4246476d285d5$var$ViewPageReactionsContainer, {
                id: "view-page-reactions-container",
                "data-vc": "view-page-reactions-container",
                "data-testid": "view-page-reactions-container",
                "data-test-id": "view-page-reactions-container"
            }, t2);
            $[16] = t2;
            $[17] = t3;
        } else t3 = $[17];
        return t3;
    }
    return null;
} : ({ hasReactions: hasReactions, contentType: contentType, contentId: contentId, spaceId: spaceId, contentSubType: contentSubType })=>{
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const displayReactions = ()=>{
        if (contentType && spaceId) {
            // We want to load in the background ONLY if we have a query param, otherwise we can preload the query
            const ReactionsLoader = Boolean(focusedPageReactionsId) ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $1NF8X.ReactionsLoader);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ReactionsLoader, {
                contentId: contentId,
                location: contentType,
                containerId: spaceId,
                containerType: (0, $2ttXz.ReactionContainerType).SPACE,
                contentSubType: contentSubType,
                customAnalyticsAttributes: {
                    edition: edition,
                    reactionsPlacement: 'bottom'
                }
            });
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    };
    if (renderServerPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36f4246476d285d5$var$ViewPageReactionsContainer, {
        id: "view-page-reactions-container",
        "data-vc": "view-page-reactions-container-server-placeholder",
        "data-testid": "view-page-reactions-container",
        "data-test-id": "view-page-reactions-container"
    }, isReactionsEnabled && hasReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
        useAccuratePills: true
    }));
    else if (state?.isContentReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36f4246476d285d5$var$ViewPageReactionsContainer, {
        id: "view-page-reactions-container",
        "data-vc": "view-page-reactions-container",
        "data-testid": "view-page-reactions-container",
        "data-test-id": "view-page-reactions-container"
    }, hasReactions && isReactionsEnabled && displayReactions());
    return null;
};


















var $98zed = parcelRequire("98zed");

const $4d9db4017ca6ca1d$export$fb2757b0aa0b047e = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { contentId: contentId, cachedSubType: cachedSubType, cachedIsArchived: cachedIsArchived, renderLivePageAsViewPage: renderLivePageAsViewPage } = t0;
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { isLive: isLive, isTypeKnown: isTypeKnown } = (0, $98zed.useIsLivePageWithSSR)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useRenderLivePageEarlyContentSubTypeAndStatusQuery($contentId:ID!$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id status subType}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = isTypeKnown || !(isLivePagesFeatureEnabled && !renderLivePageAsViewPage && cachedSubType === "live");
    let t4;
    if ($[3] !== t2 || $[4] !== t3) {
        t4 = {
            variables: t2,
            skip: t3,
            fetchPolicy: "network-only"
        };
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { data: latestContentData, loading: isContentDataLoading } = (0, $xQxzY.useQuery)(t1, t4);
    if (isTypeKnown) {
        const t5 = Boolean(isLive);
        let t6;
        if ($[6] !== t5) {
            t6 = {
                renderLivePageEarly: t5,
                isLivePageCacheOutdated: false,
                isFastLoadedLivePageArchived: false,
                isLivePageFastLoadedFromSSR: true
            };
            $[6] = t5;
            $[7] = t6;
        } else t6 = $[7];
        return t6;
    }
    const loadedSubType = latestContentData?.content?.nodes?.[0]?.subType;
    const mostRecentSubType = isContentDataLoading ? cachedSubType : loadedSubType;
    const loadedIsArchived = latestContentData?.content?.nodes?.[0]?.status === "archived";
    const mostRecentIsArchived = isContentDataLoading ? cachedIsArchived : loadedIsArchived;
    const t5 = isLivePagesFeatureEnabled && mostRecentSubType === "live" && !mostRecentIsArchived;
    const t6 = isLivePagesFeatureEnabled && cachedSubType === "live" && !isContentDataLoading && (loadedSubType !== "live" || cachedIsArchived === false && loadedIsArchived === true);
    const t7 = isLivePagesFeatureEnabled && mostRecentSubType === "live" && loadedIsArchived === true && !cachedIsArchived;
    let t8;
    if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
        t8 = {
            renderLivePageEarly: t5,
            isLivePageCacheOutdated: t6,
            isFastLoadedLivePageArchived: t7,
            isLivePageFastLoadedFromSSR: false
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ contentId: contentId, cachedSubType: cachedSubType, cachedIsArchived: cachedIsArchived, renderLivePageAsViewPage: renderLivePageAsViewPage })=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { isLive: isLive, isTypeKnown: isTypeKnown } = (0, $98zed.useIsLivePageWithSSR)();
    // To handle the scenario where the cached subtype is 'live' but outdated (it's no longer 'live'): We briefly render LivePageComponent, ContentSubTypeAndStatusQuery finishes, then
    // if ContentSubTypeAndStatusQuery returns that the subtype is not actually 'live', we will render the rest of ViewPageCommon rather than rendering LivePageComponent here.
    // To handle the scenario where cached subtype is not 'live' but outdated (it's now 'live'): We'll check for it later in this component, after loading ContentUnifiedQuery,
    // and render LivePageComponent if needed.
    const { data: latestContentData, loading: isContentDataLoading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useRenderLivePageEarlyContentSubTypeAndStatusQuery($contentId:ID!$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id status subType}}}`, {
        variables: {
            contentId: contentId
        },
        // We don't need to retrieve subtype if cachedSubType is not 'live' because we'll never enter LivePageComponent early.
        skip: isTypeKnown || !(isLivePagesFeatureEnabled && !renderLivePageAsViewPage && cachedSubType === 'live'),
        fetchPolicy: 'network-only'
    });
    // Return early if we're certain that the page is live
    if (isTypeKnown) return {
        renderLivePageEarly: Boolean(isLive),
        isLivePageCacheOutdated: false,
        isFastLoadedLivePageArchived: false,
        isLivePageFastLoadedFromSSR: true
    };
    const loadedSubType = latestContentData?.content?.nodes?.[0]?.subType;
    const mostRecentSubType = isContentDataLoading ? cachedSubType : loadedSubType;
    const loadedIsArchived = latestContentData?.content?.nodes?.[0]?.status === 'archived';
    const mostRecentIsArchived = isContentDataLoading ? cachedIsArchived : loadedIsArchived;
    // If live page is archived, render through normal view page instead of live page component
    return {
        renderLivePageEarly: isLivePagesFeatureEnabled && mostRecentSubType === 'live' && !mostRecentIsArchived,
        isLivePageCacheOutdated: isLivePagesFeatureEnabled && cachedSubType === 'live' && !isContentDataLoading && (loadedSubType !== 'live' || cachedIsArchived === false && loadedIsArchived === true),
        isFastLoadedLivePageArchived: isLivePagesFeatureEnabled && mostRecentSubType === 'live' && loadedIsArchived === true && !cachedIsArchived,
        isLivePageFastLoadedFromSSR: false
    };
};



var $6fTvc = parcelRequire("6fTvc");











var $T1bCI = parcelRequire("T1bCI");





var $hrAmX = parcelRequire("hrAmX");


var $jAfH5 = parcelRequire("jAfH5");







const $3993000b7971926b$export$d4da30e04f8ef8f8 = 'view-page-main-content-container';
const $3993000b7971926b$var$styles = {
    container: "_1e0cj4ch"
};
const $3993000b7971926b$export$1cbdd44a5a1781ff = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, isFabricPage: isFabricPage } = t0;
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const setMinHeight = isFabricPage && !hasRecs && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && ((0, $9wGTI.fg)("confluence_frontend_unify_footer_comment_spacing") || (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true));
    if (setMinHeight) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                (0, $hrAmX.BannerStateContainer)
            ];
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== children) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: t1
            }, (bannerState)=>{
                const bannerHeight = bannerState.getTotalHeight();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    xcss: $3993000b7971926b$var$styles.container,
                    style: {
                        minHeight: `calc(100vh - ${bannerHeight}px - ${46}px - ${64}px - ${14}px)`
                    },
                    testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
                    "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
                }, children);
            });
            $[1] = children;
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    } else {
        let t1;
        if ($[3] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
                "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
            }, children);
            $[3] = children;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
} : ({ children: children, isFabricPage: isFabricPage })=>{
    // Set minHeight for all Page content above footer comments, so that footer comments
    // are always placed at the bottom of viewport when Page content is short.
    // This CSS-based method is compatible with SSR. So prefer this over dynamically
    // calculating spacing using window.innerHeight, which is not available in SSR.
    // If page has EOP recommendations, don't add any spacing between it and footer
    // comments. So don't set minHeight.
    // If page is a legacy TinyMCE page (i.e. !isFabricPage), don't add spacing either.
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const setMinHeight = // eslint-disable-next-line confluence-feature-gating/no-preconditioning -- multiple fgs are used in this expression
    isFabricPage && !hasRecs && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_spacing') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true));
    if (setMinHeight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        // - bannerHeight includes top nav bar and any banner above it.
        // - ContentContainerComponent has a 46px padding top when fg('confluence_frontend_content_wrapper') is ON.
        // - ObjectAddCommentContainer has a 64px height.
        // - We lift footer comment top by 14px to make it visually distinct
        //   when a short Page has some vs zero existing footer comment.
        //   (This matches the spacing in LiveDoc.)
        const bannerHeight = bannerState.getTotalHeight();
        const contentContainerPaddingTop = 46;
        const addFooterCommentHeight = 64;
        const extraFooterCommentHeightToShow = 14;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $3993000b7971926b$var$styles.container,
            style: {
                minHeight: `calc(100vh - ${bannerHeight}px - ${contentContainerPaddingTop}px - ${addFooterCommentHeight}px - ${extraFooterCommentHeightToShow}px)`
            },
            testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
            "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
        }, children);
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
        "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
    }, children);
};












var $4u5NT = parcelRequire("4u5NT");


var $054Kg = parcelRequire("054Kg");




const $0035dfb85f61bd54$export$d43c540128020838 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ViewPageSplitTinyUFO(t0) {
    const $ = (0, $frIzR.c)(3);
    const { isFabricPage: isFabricPage } = t0;
    let t1;
    let t2;
    if ($[0] !== isFabricPage) {
        t1 = ()=>{
            if (!isFabricPage) {
                if ((0, $6mKj3.expValEquals)("cc_editor_ttvc_ft_split2", "isEnabled", true)) (0, $054Kg.updatePageloadName)("view-page-tiny");
                else (0, $4u5NT.updatePageLoadInteractionName)("view-page-tiny");
            }
        };
        t2 = [
            isFabricPage
        ];
        $[0] = isFabricPage;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t1, t2);
    return null;
} : function ViewPageSplitTinyUFO({ isFabricPage: isFabricPage }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!isFabricPage) {
            if ((0, $6mKj3.expValEquals)('cc_editor_ttvc_ft_split2', 'isEnabled', true)) (0, $054Kg.updatePageloadName)('view-page-tiny');
            else (0, $4u5NT.updatePageLoadInteractionName)('view-page-tiny');
        }
    }, [
        isFabricPage
    ]);
    return null;
};


const $abc768867d8694f5$var$LivePageComponent = (0, $8tF9d.LivePageComponentLoader);
const $abc768867d8694f5$export$7c711af41fff7bc1 = (hasAllowedFeature)=>{
    if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return hasAllowedFeature ? (0, $398ES.LoadingPriority).PAINT : (0, $398ES.LoadingPriority).LAZY;
    return null;
};
const $abc768867d8694f5$var$hideDuringPdfPrint = null; // NOTE: `contentId` represents the user's intended page but not always the displayed one. During transition to a new page, the component still renders the previous page until ViewPageContainer updates the contentQueryData.
const $abc768867d8694f5$export$77ec5b273f6febda = ({ spaceKey: spaceKey, contentId: contentId, contentHeader: contentHeader, contentScreenStyles: contentScreenStyles, classicComments: classicComments, eventHandlers: eventHandlers, titleAndByLineOptions: titleAndByLineOptions, hasByLine: hasByLine = true, hasPageComments: hasPageComments = true, hasSatisfactionSurveys: hasSatisfactionSurveys = true, hasInlineComments: hasInlineComments = true, hasInlineActions: hasInlineActions = true, hasLabels: hasLabels = true, hasReactions: hasReactions = true, hasEOPRecs: hasEOPRecs = true, hasQuickReload: hasQuickReload = true, hasProgressiveRendering: hasProgressiveRendering, appearance: appearance, children: children, setHasCoverPicture: setHasCoverPicture, isEmbeddedPage: isEmbeddedPage, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, renderLivePageAsViewPage: renderLivePageAsViewPage = false, cachedPageData: cachedPageData = {} })=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const setContentLastModifiedTimestamp = (0, $hq2Sz.useSetContentLastModifiedTimestamp)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled, livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { isLivePage: isLivePageOnSSR } = (0, $60cDW.getSSRRenderInputs)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    let { embeddedConfluenceSource: embeddedConfluenceSource } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    if (!embeddedConfluenceSource && isEmbeddedPage) embeddedConfluenceSource = (0, $jiJCD.parse)(location.search, true).query.embeddedConfluenceSource?.toString();
    const isPdfExport = (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const isReadingAidsAutoHighlightEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en'); // Setup for A/A experiment for testing stratified sampling with Statsig
    (0, $6mKj3.expVal)('cc_stratified_sampling_exp_aa', 'cohort', 'not-controlled');
    let stickyHeader = contentHeader;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsLive: setIsLive } = (0, $efvKr.useLivePageStoreActions)();
    const [pageCommentsSectionRef, pageCommentsSectionInView] = (0, $iHQDd.useInView)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const shouldShowBylineReactions = hasReactions && !isLivePage && (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline');
    const setLivePageGlobalState = (0, $42omo.useCallback)((isContentLive)=>{
        setIsLive(isContentLive);
        (0, $78QFu.setIsLivePage)(isContentLive); // page load state used for analytics context (e.g. for experience tracking)
    }, [
        setIsLive
    ]);
    (0, $4d7d073c1c91ca91$export$7ac5f7e6449ca924)({
        skip: !(0, $6mKj3.expVal)('cc_engagement_amplitude_session_replay_exp', 'isEnabled', false)
    });
    (0, $bd6002357c1db080$export$d42c6c42be666145)({
        contentId: contentId,
        skip: !(0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate')
    });
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage) return; // no cleanup needed
        // This is the cleanup function that runs when the component unmounts
        return ()=>{
            setLivePageGlobalState(false);
        };
    }, [
        isLivePage,
        setLivePageGlobalState
    ]); // Update view-page experience with `isLivePage` && `livePageReleasePhase` attributes to ensure all future experience fails denote whether it was on a live page
    (0, $42omo.useEffect)(()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_PAGE_EXPERIENCE));
        if (experienceState?.attributes?.contentId === contentId && experienceState?.attributes?.isLivePage !== isLivePage) experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            attributes: {
                isLivePage: isLivePage,
                livePageReleasePhase: livePageReleasePhase
            }
        });
    }, [
        contentId,
        isLivePage,
        livePageReleasePhase,
        experienceTracker
    ]); // stickyHeader needs to be removed based on live page state since it's used in ViewPageContainer props
    if (isLivePage) stickyHeader = undefined;
    const { renderLivePageEarly: renderLivePageEarly, isLivePageCacheOutdated: isLivePageCacheOutdated, isFastLoadedLivePageArchived: isFastLoadedLivePageArchived, isLivePageFastLoadedFromSSR: isLivePageFastLoadedFromSSR } = (0, $4d9db4017ca6ca1d$export$fb2757b0aa0b047e)({
        contentId: contentId,
        cachedSubType: cachedPageData.subType,
        cachedIsArchived: cachedPageData.isArchived,
        renderLivePageAsViewPage: renderLivePageAsViewPage
    });
    (0, $42omo.useEffect)(()=>{
        if (renderLivePageEarly) setLivePageGlobalState(true);
    }, [
        renderLivePageEarly,
        setLivePageGlobalState
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                resetInitialDataLoadedMap();
                clearCommentsData();
            }
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    let livePageFastLoadedSource = '';
    if (renderLivePageEarly) {
        if (isLivePageFastLoadedFromSSR) livePageFastLoadedSource = 'SSR';
        else if (cachedPageData?.gqlType) livePageFastLoadedSource = `GQL:${cachedPageData.gqlType}`;
        else livePageFastLoadedSource = 'Unknown';
    }
    const { successfulExperiences: previousRouteSuccessfulExperiences } = (0, $fGzMp.getPreviousRouteExperienceData)();
    const livePagePerfData = (0, $42omo.useMemo)(()=>({
            renderLivePageEarly: renderLivePageEarly,
            isLivePageCacheOutdated: isLivePageCacheOutdated,
            isFastLoadedLivePageArchived: isFastLoadedLivePageArchived,
            isLivePageFastLoadedFromSSR: isLivePageFastLoadedFromSSR,
            livePageFastLoadedSource: livePageFastLoadedSource,
            contentExtensionMetrics: {},
            previousRouteSuccessfulExperiences: Array.from(previousRouteSuccessfulExperiences)
        }), [
        renderLivePageEarly,
        isLivePageCacheOutdated,
        isFastLoadedLivePageArchived,
        isLivePageFastLoadedFromSSR,
        livePageFastLoadedSource,
        previousRouteSuccessfulExperiences
    ]);
    const panelsModuleKeysAtlGeneral = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    });
    const panelsModuleKeysAtlFooter = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    });
    const customPerfData = {
        ...livePagePerfData,
        webPanelsAtlGeneral: panelsModuleKeysAtlGeneral,
        webPanelsAtlFooter: panelsModuleKeysAtlFooter,
        ...embeddedConfluenceSource ? {
            embeddedConfluenceSource: embeddedConfluenceSource
        } : {}
    };
    const { isAMN: isAMN, isLoading: isAMNPagePropertiesLoading, isRecurringParent: isRecurringParent, isLiveAMNPage: isLiveAMNPage } = (0, $iSXh4.useAutomatedMeetingNotesPageProperties)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // maintain analytics for AMN page views without triggering spotlight
        if (!isAMNPagePropertiesLoading && isAMN) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewAMNPage',
                attributes: {
                    isLivePage: isLiveAMNPage,
                    isRecurringParent: isRecurringParent,
                    referralSource: (0, $iVU5h.getAMNReferralSourceFromQueryParam)()
                }
            }
        }).fire();
    }, [
        contentId,
        isAMN,
        isRecurringParent,
        isLiveAMNPage,
        isAMNPagePropertiesLoading,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNzRA.ObjectCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4r9Ir.NewCommentsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7IghX.PageCommentsCountProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8ZQ3.DocumentUpdateStatusProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pQ1Y.ContentRefetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8WQTF.RendererActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, renderLivePageEarly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abc768867d8694f5$var$LivePageComponent, {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
        customPerfData: customPerfData,
        loadingPriority: $abc768867d8694f5$export$7c711af41fff7bc1(true),
        isFastLoaded: true,
        hasByLineContributors: titleAndByLineOptions?.hasByLineContributors ?? true,
        hasByLineExtensions: titleAndByLineOptions?.hasByLineExtensions ?? true,
        hasReactions: hasReactions,
        hasPageComments: hasPageComments,
        hasInlineComments: hasInlineComments
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (()=>{
        // Extract render function to avoid duplication
        const renderViewPageContent = ({ isThemed: isThemed, contentQueryData: contentQueryData, contentQueryError: contentQueryError })=>{
            const contentStatus = contentQueryData?.content?.nodes?.[0]?.status;
            const contentType = contentQueryData?.content?.nodes?.[0]?.type;
            const contentSubType = contentQueryData?.content?.nodes?.[0]?.subType;
            const contentTitle = contentQueryData?.content?.nodes?.[0]?.title;
            const spaceId = contentQueryData?.content?.nodes?.[0]?.space?.id;
            const contentIdFromQuery = contentQueryData?.content?.nodes?.[0]?.id;
            const lastModifiedDate = contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate;
            setContentLastModifiedTimestamp(lastModifiedDate);
            const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
            const isFabricPage = Boolean(contentQueryData?.content?.nodes?.[0]?.body?.dynamic?.representation === 'atlas_doc_format');
            const hasLegacyContent = contentQueryData?.content?.nodes?.[0]?.body?.dynamic?.value?.includes('"extensionKey":"legacy-content"');
            const showAIButton = (contentType === 'page' || contentType === 'blogpost') && !isEmbeddedPage;
            const showAIButtonForTinyMCE = !isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper'); // getting info cover picture needs
            const { coverPicture: coverPicture, contentAppearance: contentAppearance, hasCoverPicture: hasCoverPicture, coverPictureWidth: coverPictureWidth } = (0, $3WPGR.getRendererCoverPictureInfo)(contentQueryData, false); // getting info for auto conversion
            const { queryDataId: queryDataId, editorProperty: editorProperty, isAutoConverted: isAutoConverted, fabricEditorSupported: fabricEditorSupported } = (0, $ayQVU.getAutoConvertionInfo)(contentQueryData?.content?.nodes?.[0]); // If live page is archived, we don't show LivePageComponent. Instead, archived live pages will render using the existing ViewPageContentRenderer.
            const isContentLive = isLivePageOnSSR || contentQueryData?.content?.nodes?.[0]?.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE) && contentStatus !== 'archived';
            if (isLivePagesFeatureEnabled) {
                setLivePageGlobalState(isContentLive);
                if (isContentLive && !contentQueryError && !!contentIdFromQuery && !renderLivePageAsViewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
                    scope: contentId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abc768867d8694f5$var$LivePageComponent, {
                    contentId: contentIdFromQuery,
                    spaceKey: spaceKey,
                    ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
                    customPerfData: customPerfData,
                    isFastLoaded: false,
                    hasByLineContributors: titleAndByLineOptions?.hasByLineContributors ?? true,
                    hasByLineExtensions: titleAndByLineOptions?.hasByLineExtensions ?? true,
                    hasReactions: hasReactions,
                    hasPageComments: hasPageComments,
                    hasInlineComments: hasInlineComments
                }));
            }
            if (!!setHasCoverPicture) setHasCoverPicture(hasCoverPicture);
            const livePagePublishExperienceState = experienceTracker.getExperienceState((0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE));
            if (livePagePublishExperienceState && !livePagePublishExperienceState.hasStopped && livePagePublishExperienceState.attributes?.contentId === contentId) {
                // Succeed the live-page/publish and live-page-session experiences on render of view page content after conversion to page
                experienceTracker.succeed({
                    name: (0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE)
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE),
                    attributes: {
                        convertedToPage: true
                    }
                });
            }
            const importedContentSource = (0, $aK6zf.getImportSource)(contentQueryData);
            const importedContentDate = (0, $aK6zf.getImportDate)(contentQueryData);
            const isImportBannerShown = (0, $aK6zf.isImportBannerEnabled)(contentQueryData) && importedContentSource && importedContentDate;
            const maybeScrollToPageStart = Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kJNMt.ScrollToPageStart), {
                key: `ScrollToPageStart-${contentId}`,
                isSmooth: false
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, maybeScrollToPageStart, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3993000b7971926b$export$1cbdd44a5a1781ff), {
                isFabricPage: isFabricPage
            }, isThemed && contentHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0035dfb85f61bd54$export$d43c540128020838), {
                isFabricPage: isFabricPage
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
                type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).HEADER
            }), isImportBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99af38a0b1766526$export$f2bf6e79bf9b9470), {
                importSource: importedContentSource,
                importDate: importedContentDate,
                contentId: contentId
            }), hasCoverPicture && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oWMY.RendererPageCoverPicture), {
                contentId: contentId,
                isPagePreview: false,
                coverPicture: coverPicture,
                contentAppearance: contentAppearance,
                isSpaceOverview: false,
                coverPictureWidthOverride: coverPictureWidth
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UMDm.AutoConversionByLineContextProvider), {
                editorProperty: editorProperty,
                fabricEditorSupported: fabricEditorSupported,
                isAutoConverted: !!isAutoConverted,
                queryDataId: queryDataId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
                contentId: contentId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGhsu.ContentTitleWithByLine), {
                banner: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deZfn.ArchivedPageBannerAfterPaint), {
                    contentId: contentId
                }),
                contentId: contentId,
                spaceKey: spaceKey || '',
                hasCoverPicture: hasCoverPicture,
                pageWidthType: pageWidthType,
                isEmbeddedPage: isEmbeddedPage,
                shouldShowBylineReactions: shouldShowBylineReactions,
                contentType: contentType,
                contentSubType: contentSubType,
                spaceId: spaceId,
                ...titleAndByLineOptions,
                hasByLine: hasByLine
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6fTvc.ViewPageContent), {
                hasInlineComments: hasInlineComments,
                hasProgressiveRendering: hasProgressiveRendering,
                contentId: contentId,
                data: contentQueryData,
                error: contentQueryError,
                spaceKey: spaceKey,
                eventHandlerOverrides: eventHandlers,
                appearance: appearance,
                hasInlineActions: hasInlineActions,
                lastModifiedDate: lastModifiedDate || undefined,
                isEmbeddedPage: isEmbeddedPage,
                customPerfData: customPerfData,
                disableTableOverflowShadow: true
            }), (0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $627671e2381ceaa8$export$a4224605ab1026cb), {
                contentID: contentId,
                spaceKey: spaceKey
            }), hasInlineComments && (!isFabricPage || hasLegacyContent && !(0, $9wGTI.fg)('confluence_comment_disable_legacy_comment')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4yKPM.InlineCommentsHighlighterLoader), {
                pageId: contentId
            }), isReadingAidsAutoHighlightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pBXK.ReadingAidsAcronymsHighlighter), {
                contentId: contentId
            }), hasLabels && (isFabricPage && (0, $9wGTI.fg)('confluence_frontend_labels_in_footer') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZEms.ViewPageLabelsLoader), {
                pageWidthType: pageWidthType,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                spaceId: spaceId,
                contentSubType: contentSubType
            })), hasEOPRecs && (contentType == 'page' || contentType == 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fIKxq.EndOfPageRecommendationFinalLoader), {
                entityType: contentType || '',
                entityId: contentId,
                spaceKey: spaceKey || '',
                pageWidthType: pageWidthType
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyPYm.ContentViewedEvent), {
                contentId: contentId
            }), (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hd53J.CommentsDataBackgroundLoader), {
                contentId: contentId
            })), isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_24zuglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lrMxq.ObjectSidebarControl), {
                hasCommentsButton: true,
                hasDetailsButton: true,
                hasLoomButton: contentStatus !== 'archived',
                hasAiButton: showAIButton,
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                contentTitle: contentTitle,
                lastModifiedDate: lastModifiedDate,
                pageCommentsSectionInView: pageCommentsSectionInView,
                hasAudioButton: isAIEnabledForContent
            })), hasReactions && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /* Disable unsupported reactions when rendering live page as view page */ !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
                contentId: contentId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36f4246476d285d5$export$b2a33efe33addcf5), {
                hasReactions: hasReactions,
                contentId: contentId,
                contentType: contentType,
                spaceId: spaceId,
                contentSubType: contentSubType
            })) : !(isPdfExport || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && // Hide divider if pdf export or new footer comment style (which has its own divider)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdcf7379ee3b47$export$2e0a83ec2e27ecbb), {
                testId: "reaction-placeholder-divider"
            })), hasPageComments && /* Disable unsupported page comments when rendering live page as view page */ !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $9wGTI.fg)('confluence_comment_sticky_footer_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2xS8W.StickyDraftCommentContainer), {
                pageWidthType: pageWidthType,
                key: `StickyDraftCommentContainer-${contentId}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "renderer-footer-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ref: pageCommentsSectionRef,
                "data-vc": "footer-comments"
            }, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f8c76250771e531$export$3469ece96a08b09e), {
                key: contentId,
                contentId: contentId,
                loadingPriority: (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? (0, $398ES.LoadingPriority).PAINT : $abc768867d8694f5$export$7c711af41fff7bc1(hasPageComments),
                classicComments: classicComments,
                hasReactions: hasReactions
            }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70pcM.ObjectCommentWrapper), {
                showGeneralComment: true,
                showLabels: Boolean(hasLabels) && isFabricPage,
                pageWidthType: pageWidthType,
                loadingPriority: (0, $9wGTI.fg)('confluence_frontend_ssr_empty_footer_comments') ? (0, $398ES.LoadingPriority).PAINT : undefined,
                key: `ObjectCommentWrapper-${contentId}`,
                hasReactions: hasReactions
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dJ5r4.ViewCommentShortcutListener), {
                isFabricPage: isFabricPage,
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
                type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).FOOTER
            }), isFabricPage && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNYtG.PageCommentsPubSubHandler), {
                contentId: contentId,
                contentType: contentType
            }), hasQuickReload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jXhAV.QuickReload), {
                contentId: contentId,
                contentType: contentType,
                // package on what a more correct lastPollTime value would be.
                lastPollTime: Date.now(),
                pageMode: (0, $fSC8h.PageMode).RENDERER,
                pageCommentsSectionInView: pageCommentsSectionInView,
                isFabricPage: isFabricPage
            }), hasSatisfactionSurveys && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $889eab36c217c00c$export$bdd4a5944172b352), {
                spaceKey: spaceKey,
                contentId: contentId,
                isEditorExpEnabled: (0, $9wGTI.fg)('cc_onboarding_experience')
            }), contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cMKmt.LocalActivityViewPageTracker), {
                contentId: contentId
            }), children, hasInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9450efcd5fbf758a$export$9fdf0be90cc81aa6), {
                key: contentId,
                loadingPriority: $abc768867d8694f5$export$7c711af41fff7bc1(hasInlineComments),
                contentId: contentId,
                isFabricPage: isFabricPage
            }), isLivePagesFeatureEnabled && contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmBjr.ConvertToLivePageFlag), null), (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfmjq.MovePageSuccessFlag), null), showAIButton && showAIButtonForTinyMCE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f23f475309e66803$export$9533f8bbe7f6f635), {
                spaceKey: spaceKey ?? '',
                contentId: contentId,
                contentType: contentType,
                lastModifiedDate: lastModifiedDate,
                pageCommentsSectionInView: pageCommentsSectionInView
            }));
        };
        return !isEmbeddedPage && (0, $9wGTI.fg)('twcg-392_export_jira_context_to_page_killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8e93420dd4224227$export$dd15d35ca66ec3f8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXika.ViewPageContainer), {
            spaceKey: spaceKey,
            contentId: contentId,
            stickyHeader: stickyHeader,
            contentScreenStyles: contentScreenStyles,
            customPerfData: customPerfData
        }, renderViewPageContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXika.ViewPageContainer), {
            spaceKey: spaceKey,
            contentId: contentId,
            stickyHeader: stickyHeader,
            contentScreenStyles: contentScreenStyles,
            customPerfData: customPerfData
        }, renderViewPageContent);
    })())))))))))));
};
module.exports["ViewPageCommon"] = $abc768867d8694f5$export$77ec5b273f6febda;

});

parcelRegister("7mat2", function(module, exports) {

let $55b2b5148b0b4ea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $55b2b5148b0b4ea1$var$load("2dtmW"),
    $55b2b5148b0b4ea1$var$load("6wr18"),
    $55b2b5148b0b4ea1$var$load("dFVoN"),
    $55b2b5148b0b4ea1$var$load("i0ttV"),
    $55b2b5148b0b4ea1$var$load("95zCL"),
    $55b2b5148b0b4ea1$var$load("iK6Gk"),
    $55b2b5148b0b4ea1$var$load("fD0v8"),
    $55b2b5148b0b4ea1$var$load("6XCf4"),
    $55b2b5148b0b4ea1$var$load("5pvpJ"),
    $55b2b5148b0b4ea1$var$load("ffEVr"),
    $55b2b5148b0b4ea1$var$load("1qlDN"),
    $55b2b5148b0b4ea1$var$load("1yVM6"),
    $55b2b5148b0b4ea1$var$load("3tGwt")
]).then(()=>parcelRequire('6UCCJ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3ql08", function(module, exports) {

let $27e4172d2846d169$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27e4172d2846d169$var$load("czC5b").then(()=>parcelRequire('d1GUC'));

});

parcelRegister("8E6no", function(module, exports) {

let $64b7015f1975e8bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b7015f1975e8bc$var$load("cJccL").then(()=>parcelRequire('ll9YW'));

});


//# sourceMappingURL=ViewPagePdfExportPage.82f4cc45.js.map
